/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Iaso
 * Iaso Swagger
 * OpenAPI spec version: v1
 */
import { z as zod } from 'zod';

export const apiValidationWorkflowsCreateBodyNameMax = 256;

export const apiValidationWorkflowsCreateBodyDescriptionMax = 1024;

export const ApiValidationWorkflowsCreateBody = zod.strictObject({
    name: zod.string().min(1).max(apiValidationWorkflowsCreateBodyNameMax),
    description: zod
        .string()
        .max(apiValidationWorkflowsCreateBodyDescriptionMax)
        .optional(),
    forms: zod.array(zod.number()).optional(),
});

export type ApiValidationWorkflowsCreateBody = zod.input<
    typeof ApiValidationWorkflowsCreateBody
>;
export type ApiValidationWorkflowsCreateBodyOutput = zod.output<
    typeof ApiValidationWorkflowsCreateBody
>;
